import UnifiedOtpVerification from './OtpVerification';

export default UnifiedOtpVerification;
